import { ANNOUNCEMENT_STATUS } from '../types'
export default (state = true, action) => {
  switch (action.type) {
    case ANNOUNCEMENT_STATUS:
      return action.payload
    default:
      return state;
  }
}
